import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import OrderAnalytics from './components/order-analytics';
import PasswordAuth from './components/auth/PasswordAuth';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const validateToken = (token) => {
  try {
    const decoded = atob(token);
    const [password, time] = decoded.split('_');
    const elapsed = new Date().getTime() - parseInt(time);
    return password === process.env.REACT_APP_AUTH_PASSWORD && elapsed < 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token && validateToken(token)) {
      setIsAuthenticated(true);
    }
  }, []);

  if (!isAuthenticated) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PasswordAuth onAuth={setIsAuthenticated} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ 
        backgroundColor: '#f5f5f5',
        height: '100vh',
        overflow: 'hidden'
      }}>
        <OrderAnalytics />
      </Box>
    </ThemeProvider>
  );
}

export default App;
